<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i class="fa fa-times appendIcon clickIcon" @click="resetSearch"></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredOrders"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        ></b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import cTable from "@/views/base/Table.vue";
//import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "ClientDirectOrders",
  data: () => {
    return {
      fields: [
        {
          key: "OrderID",
          label: "Invoice Number",
          sortable: true
        },
        {
          key: "CustomerID",
          label: "Customer ID",
          sortable: true
        },
        {
          key: "RecipientQuantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "RAName",
          label: "Client",
          sortable: true
        },
        {
          key: "RACompany",
          label: "Company",
          sortable: true
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 50,
      filteredOrders: [],
      filterStatus: "all",
      searchString: ""
    };
  },
  props: {},
  components: {
    cTable
    //MyBaseTable
  },
  created() {
    // alert("created");
    // this.$store
    //   .dispatch("mcap/getClientDirectOrders")
    //   .then(
    //     (this.filteredOrders = this.$store.state.mcap.client_direct_orders)
    //   );
  },
  mounted() {
    this.filterList();
    //    this.$store
    //   .dispatch("mcap/getClientDirectOrders")
    //   .then(
    //     (this.filteredOrders = this.$store.state.mcap.client_direct_orders)
    //   );
  },
  computed: {
    ...mapGetters({
      totalRows: "mcap/OrderCount"
    }),
    //totalRows: this.filteredOrders.length(),
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    ...mapState(["order", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    filterList: function() {
      this.filteredOrders = this.$store.state.mcap.client_direct_orders;
      this.filteredOrders = this.filteredOrders.filter(
        ord =>
          ord.OrderID.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.CustomerID.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.RAName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.RACompany.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    myRowClickHandler(record, index) {
      this.$store.dispatch("mcap/loadOrderEdit", record.OrderID).then(
        this.$store.dispatch("mcap/loadRecipients", record.OrderID).then(() => {
          this.$router.push({ name: "ClientDirectOrder" });
        })
      );
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>